import exploreSchemeHeaderEn from "./locales/en.json";

export const EXPLORE_SCHEME_HEADER_NS = "exploreSchemeHeader" as const;

export const ExploreSchemeHeaderI18n = {
  en: {
    [EXPLORE_SCHEME_HEADER_NS]: {
      ...exploreSchemeHeaderEn,
    },
  },
};
